<template>

	<div class="container main-content">
			
		<div class="row" v-if="$gstate.getTxnType() == 'BUY'">
			<div class="price-in convert-col col-sm-12 col-md-4 col-lg-4 text-center">
				<h4>Amount to spend</h4>
				<div class="row">
					<div class="col-12">
						<div style="display: block">
							<span class="large-inputs large-inputs-fiat">{{ $gstate.getCurrencySymbol(pq.fiatCurrency) }}{{ pq.fiatAmount | num2decimal }}&nbsp;<span class="large-inputs-suffix">{{ pq.fiatCurrency }}</span></span>
						</div>
						<div>
							<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
						</div>
					</div>
				</div>				
			</div>
			<div class="convert-col col-sm-12 col-md-4 col-lg-4 text-center">
				<div class="convert-icon mb-2" alt="Convert"></div>
				<p>
					<span>{{ $gstate.getCurrencySymbol(pq.fiatCurrency) }}1 {{ pq.fiatCurrency }} = {{ ( pq.cryptoAmount / pq.fiatAmount ) | num8decimal }}&nbsp;{{ pq.cryptoCurrency }}</span><br>
					<span style="font-size: 10px;">{{ getFeeMsg }}</span>
				</p>
				<div v-if="$gstate.isPromo()" class="mt-4 row">
					<div class="promo col-8 offset-2 offset-md-0 col-md-12">
						<div class="checkmark-inline mr-2" alt="Checkmark"></div><span v-if="getPromoFee() == 0"><strong>NO PROCESSING FEES.</strong></span><br />You saved ${{ getPromoSavingsFiat() }} {{ pq.fiatCurrency }}
					</div>
				</div>
				<div class="mt-5 row" v-if="$gstate.getPaymentMethod() == 'CREDITCARD'">
					<div class="usd-warning col-8 offset-2 offset-md-0 col-md-12">
						<div class="exclamation-inline mr-2" alt="Exclamation"></div>Credit cards charged in USD
					</div>
				</div>
			</div>
			<div class="crypto-out convert-col col-sm-12 col-md-4 col-lg-4 text-center">
				<h4>You will receive</h4>
				<div class="row">
					<div class="col-12">
						<div style="display: block">
							<span class="large-inputs large-inputs-crypto">{{ pq.cryptoAmount | num8decimal }}&nbsp;<span class="large-inputs-suffix">{{ pq.cryptoCurrency }}</span></span>
						</div>
						<div>
							<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row" v-if="$gstate.getTxnType() == 'SELL'">
			<div class="crypto-out convert-col col-sm-12 col-md-4 col-lg-4 text-center">
				<h4>Amount to send</h4>
				<div class="row">
					<div class="col-12">
						<div style="display: block">
							<span class="large-inputs large-inputs-fiat">{{ pq.cryptoAmount | num8decimal }}&nbsp;<span class="large-inputs-suffix">{{ pq.cryptoCurrency }}</span></span>
						</div>
						<div>
							<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
						</div>
					</div>
				</div>
			</div>
			<div class="convert-col col-sm-12 col-md-4 col-lg-4 text-center">
				<div class="convert-icon mb-2" alt="Convert"></div>
				<p>
					<span>1&nbsp;{{ pq.cryptoCurrency }} = {{ $gstate.getCurrencySymbol(pq.fiatCurrency) }} {{ ( pq.fiatAmount / pq.cryptoAmount ) | num2decimal }} {{ pq.fiatCurrency }}</span><br>
					<span style="font-size: 10px;">{{ getFeeMsg }}</span>
				</p>
			</div>
			<div class="price-in convert-col col-sm-12 col-md-4 col-lg-4 text-center">
				<h4>You will receive</h4>
				<div class="row">
					<div class="col-12">
						<div style="display: block">
							<span class="large-inputs large-inputs-crypto">{{ $gstate.getCurrencySymbol(pq.fiatCurrency) }}{{ pq.fiatAmount | num2decimal }}&nbsp;<span class="large-inputs-suffix">{{ pq.fiatCurrency }}</span></span>
						</div>
						<div>
							<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
						</div>
					</div>
				</div>				
			</div>
		</div>
		<div class="row mb-4 mt-2 pb-2">
			<div class="col-12 col-md-4 offset-md-4 text-center">
				<p>By continuing, you agree and consent to the <a target="_blank" v-bind:href="tosURL">Terms of Service</a> and <a target="_blank" v-bind:href="ppURL">Privacy Policy</a></p>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-center">
				<a href="#" id="price-quote-next" v-if="!isProcessing" class="btn next-btn" :class="{'disabled' : isProcessingRequote }" ref="btnNext" v-on:click.prevent="confirm">NEXT</a>
				<a href="#" class="btn next-btn disabled" v-on:click.prevent="noop" v-if="isProcessing">PLEASE WAIT... <i class="fas fa-circle-notch fa-spin"></i></a>
			</div>
		</div>
	</div>

</template>

<script>

import { eventBus } from './../main'

export default {
	mounted() {

		this.$gstate.log("refId: " + this.pq.refId);

		this.$refs.btnNext.focus();
		this.$emit('setRateHoldTimer', true);
		this.$emit('setLeaveNotification', true);

		if(this.$gstate.isProd()){
			this.logUserAgent();
		}

	},
	data() {
		return {
			pq: this.$gstate.getFlowState(),
			isProcessingRequote: false,
			isProcessing: false,
			hasError: false,
			errorMessage: '',
			showModal: false,
			newPq: {},
		}
	},
	computed: {
		tosURL: function() {

			var urlstr = this.$gstate.getSiteURL() + '/terms-of-service';
			if(!this.$gstate.isCoincurve()){
				urlstr = "/#/terms-of-service";
			}

			return urlstr;
			
		},
		ppURL: function() {
			
			var urlstr = this.$gstate.getSiteURL() + '/privacy-policy';
			if(!this.$gstate.isCoincurve()){
				urlstr = "/#/privacy-policy";
			}

			return urlstr;
		},
		getFeeMsg: function() {
			return '(all fees included)';
		}
	},
	created(){
		eventBus.$on('nextScreen', this.confirm);
		eventBus.$on('refreshPq', this.refreshPq);
	},
	beforeDestroy(){
		eventBus.$off('nextScreen', this.confirm);
		eventBus.$off('refreshPq', this.refreshPq);
	},
	methods: {
		confirm: function() {
			eventBus.$emit('logGTMTransactionEvent', "transactionCreated");
			this.$gstate.performNextAction(this);
		},
		refreshPq: function (){
			this.pq = this.$gstate.getFlowState();
		},
		logUserAgent(){

			var data = new FormData();
			data.append('refId', this.$gstate.getRefId());
			data.append('width', window.screen.width);
			data.append('height', window.screen.height);

			var urlstr = 'https://coincurve.com/user-agent.php';
			this.axios.post(urlstr, data, this.$gstate.getAxiosHeaders())
				// eslint-disable-next-line
				.then(response => {
					
				})
				// eslint-disable-next-line
				.catch(error => {
					
				});
		},
		actionModal(action){
			if(action == "yes"){

				this.showModal = false;
				this.isProcessing = true;

				this.pq = this.newPq;

				// all values on the quote page update, then we automatically set to processing 
				var urlstr = this.$gstate.getApiBaseURL() + '/confirmednewquote';
				this.axios.post(urlstr, {
					refId : this.newPq.refId
				},
				this.$gstate.getAxiosHeaders())
					.then(response => {

						this.isProcessing = false;

						this.$gstate.log(response);
						this.newPq = response.data;

						// temporarily putting this until the actual API provides this data
						this.newPq.fiatAmount = this.pq.fiatAmount;
						this.newPq.fiatCurrency = this.pq.fiatCurrency;

						// save the new quote
						this.$gstate.saveFlowState(this.newPq);
						
						// refresh page vars
						this.pq = this.newPq;

						// update the rate hold timer
						eventBus.$emit('updateTimer', this.newPq.txnValidUntil);

						// for debug
						this.$gstate.log("New refId: " + this.newPq.refId)

					})
					.catch(error => {

						this.hasError = true;
						this.errorMessage = error.response.data.error.msg;
						this.isProcessing = false;

					});

			} else {

				// close modal
				this.showModal = false;
			}
		},
		getPromoFee(){

			if(this.$gstate.getPaymentMethod() == 'ETRANSFER'){
				return this.$gstate.getEtransferFeePromo();
			}

			if(this.$gstate.getPaymentMethod() == 'FLEXEPIN'){
				return this.$gstate.getFlexepinFeePromo();
			}

		},
		getPromoSavingsPercent(){

			var savingsPercent = 0;
			if(this.$gstate.getPaymentMethod() == 'ETRANSFER'){
				savingsPercent = this.$gstate.getEtransferFeeOrig() - this.$gstate.getEtransferFeePromo();
			}

			if(this.$gstate.getPaymentMethod() == 'FLEXEPIN'){
				savingsPercent = this.$gstate.getFlexepinFeeOrig() - this.$gstate.getFlexepinFeePromo();
			}

			return savingsPercent;
		},
		getPromoSavingsFiat(){
			return (this.pq.fiatAmount * (this.getPromoSavingsPercent() / 100)).toFixed(2);
		}
	}
}
</script>
